import getTypedObjectKeys from './getTypedObjectKeys';
/**
 * @deprecated Use removeObjectUndefinedNullValues() instead
 *
 * Warning: this function also removes all false, zero, empty string values
 */
export default function removeObjectFalsyValues(obj: object) {
  const newObj = {};
  getTypedObjectKeys(obj).forEach((prop) => {
    if (obj[prop]) {
      newObj[prop] = obj[prop];
    }
  });
  return newObj;
}
